/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BannerDto } from '../../models/banner-dto';
import { BannerUpdateDto } from '../../models/banner-update-dto';

export interface BannerControllerUpdate$Params {
  id: string;
      body: BannerUpdateDto
}

export function bannerControllerUpdate(http: HttpClient, rootUrl: string, params: BannerControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BannerDto>> {
  const rb = new RequestBuilder(rootUrl, bannerControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BannerDto>;
    })
  );
}

bannerControllerUpdate.PATH = '/api/banner/{id}';
